import React, { useState } from "react";
import styles from "../../component/mainAdmin/stdassignmentdetails.module.css";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import { givestdmarks,AddComment } from "../../Redux/action/adminassignment";
import Avatar from "react-avatar";
import { FaUser, FaPaperPlane } from "react-icons/fa";
import {ToastContainer,toast} from 'react-toastify'

function Stdassignmentdetails({
  assignmentName,
  total,
  students,
  totalMarks,
  id,
}) {
  const dispatch = useDispatch();

  // const findstd = students.find(state => state)
  const { showsinglestdass } = useSelector((state) => state.assignmentreducer);

  const [comment,setcomment] = useState('')

  console.log(comment)

  console.log(showsinglestdass);

  const [textval, settextval] = useState("");
  console.log(textval);

  const submitmarks = () => {
    if (Number(textval) > Number(totalMarks)) {
      alert("you have entered wrong value");
      return;
    } else if (textval === "") return;
    else {
      dispatch(
        givestdmarks(
          id,
          showsinglestdass.rollNo,
          (showsinglestdass.obtainMarks = textval),
          assignmentName
        )
      );
      alert("marks has been submitted");
    }
  };

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  const addcomment = () => {
    dispatch(AddComment(id,showsinglestdass.rollNo,'Admin',new Date(),comment,toast))
  }

  return (
    <div
      style={{
        width: "65vw",
        height: "83vh",
        border: "2px solid green",
        position: "relative",
      }}
    >
      <ToastContainer />
      {isObjectEmpty(showsinglestdass) ? (
        <>
          <div className={styles.headerdiv}>
            <h2>{assignmentName}</h2>
          </div>
          <div className={styles.box}>
            <div className={styles.numberdiv}>
              <h1>{total}</h1>
              <h2>Total students</h2>
            </div>
            <div className={styles.numberdiv}>
              <h1>25</h1>
              <h2>Turned In</h2>
            </div>
          </div>
          <div className={styles.headerdiv}>
            <h2>Click Any student to view Info</h2>
          </div>
        </>
      ) : (
        <>
          <div className={styles.headerdiv}>
            <h2>{showsinglestdass.stdName}</h2>
            <h5>{showsinglestdass.rollNo}</h5>
          </div>
          <div className={styles.assignmentlink}>
            <div className={styles.linkdiv}>
              <div className={styles.markdiv}>
                <h5>Assignment Link</h5>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "5px solid green",
                    marginBottom: 10,
                    padding: 0,
                  }}
                >
                  <Form.Group>
                    <Form.Control
                      className={styles.inputss}
                      maxLength={2}
                      onBlur={submitmarks}
                      value={textval}
                      onChange={(e) => settextval(e.target.value)}
                    />
                  </Form.Group>
                  <h3 style={{ fontSize: "30px", marginBottom: 15 }}>
                    /{totalMarks}
                  </h3>
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Control
                  value={showsinglestdass.assignmentLink}
                  style={{ fontSize: "25px" }}
                />
              </Form.Group>
              {/* <a href={showsinglestdass.assignmentLink}>{showsinglestdass.assignmentLink}</a> */}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 15,padding:1}} >
              <FaUser />
              <h6 style={{ marginTop: 7, marginLeft: 6 }}>Comment</h6>
            </div>
          <div className={styles.commentsshowbox}>
            {showsinglestdass?.comments && showsinglestdass?.comments.map((e,i) => {

               let date = new Date(e.time)

              return(
                <>

            <div className={styles.cmntinfo} key={i}>
              <div>
                <Avatar
                  name={e.name}
                  round={true}
                  size={40}
                  color="green"
                  fgColor="#fff"
                  style={{ marginRight: 10, color: "#000" }}
                />
              </div>
              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h6 style={{ marginRight:8}}>{e.name}</h6>
                  <h6>{`${date?.getHours()}:${String(date?.getMinutes()).length === 1 ? `0${date?.getMinutes()}` : date?.getMinutes()}`}</h6>
                </div>
                <div>
                  <h5>{e.text}</h5>
                </div>
              </div>
            </div>
            </>
              )
            })}
            
          </div>
          <div className={styles.commentbox}>
            <div
              style={{
                width: "10%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Avatar
                name={"Admin"}
                round={true}
                size={50}
                color="green"
                fgColor="#fff"
                style={{ marginRight: 10, color: "#000" }}
              />
            </div>
            <div
              style={{
                width: "75%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Form.Group className="mt-3 w-100">
                <Form.Control
                  onChange={(e) => setcomment(e.target.value)}
                  value={comment}
                  style={{ fontSize: "16px", borderRadius: "20px" }}
                />
              </Form.Group>
            </div>
            <div
              style={{
                width: "10%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FaPaperPlane size={25} color="green" onClick={addcomment}/>
            </div>
          </div>
        </>
      )}
      {/* {showsinglestdass !== {} && (
        <>
       
      )} */}
    </div>
  );
}

export default Stdassignmentdetails;
